/* eslint-disable no-param-reassign */
import { IS_CLIENT_SIDE } from 'constants/constants';

export const ClientOnly = () => (_: any, _1: string, descriptor: PropertyDescriptor) => {
  const originalMethod = descriptor.value;

  descriptor.value = function (...args: Array<any>) {
    if (!IS_CLIENT_SIDE) {
      return;
    }

    return originalMethod.apply(this, args);
  };
};
const stubFunction = () => {};

export const ShouldCall = (condition: boolean) => (
  _: any,
  __: string,
  descriptor: PropertyDescriptor,
) => {
  if (!condition) {
    descriptor.value = stubFunction;
  }

  return descriptor;
};
